import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"
import timezone from "dayjs/plugin/timezone"
dayjs.extend(utc)
dayjs.extend(timezone)

export class UseUserInfoTradingFloorModelModel {
  id?: number
  emailAddress?: string
  password?: string
  isActive?: boolean
  phoneNumber?: string
  birthDate?: string
  gender?: boolean
  displayName?: string
  roleNames?: any[]
  userToOrganizationUnit?: any[]
  projectIds?: any[]
  jobTitle?: number
  constructor() {
    this.id = undefined
  }

  public static assign(obj) {
    if (!obj) return undefined

    const newObj = Object.assign(new UseUserInfoTradingFloorModelModel(), obj)

    newObj.birthDate = obj.birthDate ? dayjs(obj.birthDate) : undefined

    return newObj
  }

  public static assigns<T>(objs) {
    const results: any[] = []
    objs?.forEach((item) => results.push(this.assign(item)))
    return results
  }
}
